import type { SearchableMenuItem } from '../../shared/constants/api.constants';

/** Filter flat menu hits by label / parent / route. Empty query → all (caller may cap). */
export function filterMenuSearchHits(
  items: SearchableMenuItem[],
  query: string,
  limit?: number
): SearchableMenuItem[] {
  const term = query.trim().toLowerCase();
  const matched = !term
    ? items
    : items.filter(item => {
        const haystack = [item.label, item.parentLabel, item.route, item.key]
          .filter(Boolean)
          .join(' ')
          .toLowerCase();
        return haystack.includes(term);
      });

  return limit == null ? matched : matched.slice(0, limit);
}

/** Drop recent URLs that are already covered by a static menu route (no duplicates). */
export function filterRecentOutsideMenu<T extends { url: string }>(
  recent: T[],
  menuRoutes: readonly string[],
  normalize: (url: string) => string = u => u
): T[] {
  const menu = new Set(menuRoutes.map(normalize));
  return recent.filter(page => !menu.has(normalize(page.url)));
}

/** Wrap active index for ↑/↓ in a result list. */
export function moveMenuSearchIndex(current: number, delta: number, length: number): number {
  if (length <= 0) {
    return 0;
  }
  return (current + delta + length) % length;
}
